import React from 'react'

const CheckIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="checkGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 220, 150, 1)" />
          <stop offset="100%" stopColor="rgba(60, 180, 110, 1)" />
        </linearGradient>
        <filter id="checkGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Circle background */}
      <circle 
        cx="12" 
        cy="12" 
        r="10" 
        fill="url(#checkGradient)"
        filter="url(#checkGlow)"
      />
      
      {/* Check mark */}
      <path 
        d="M7 12l3 3 7-7"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export default CheckIcon
